<template>
  <div class="map-vue-wrapper">
    <div class="map-vue-wrapper__nav" v-if="mailName !== 'chooseStore' && !isProduct && !((isShops || isServices) && userType === $constants.USER_TYPE.CUSTOMER)">
      <input
        ref="autocomplete"
        type="text"
        v-if="isSearchVisible"
        id="addressSearch"
        class="control control--input control-box__control map-vue-wrapper__nav-search"
        name="text"
        :placeholder="$t('start_tap_to_search')"
      />
      <div class="find_me_btn" @click="FIND_ME" v-if="!isCheckout">
        <svg width="30"
             height="30"
             viewBox="0 0 30 30"
             fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <ellipse cx="15"
                   cy="25.8889"
                   rx="11"
                   ry="3.11111"
                   fill="#E7E7E7" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.9588 25.5748C15.9588 25.5748 24.9832 18.4064 24.9832 10.6662C24.9832 5.32771 20.5136 1 15 1C9.48651 1 5.0169 5.32771 5.0168 10.6662C5.0168 18.4064 14.0412 25.5748 14.0412 25.5748C14.5685 25.9936 15.4315 25.9936 15.9588 25.5748ZM14.9997 16.1803C18.0145 16.1803 20.4585 13.8153 20.4585 10.8979C20.4585 7.98055 18.0145 5.61556 14.9997 5.61556C11.9849 5.61556 9.54088 7.98055 9.54088 10.8979C9.54088 13.8153 11.9849 16.1803 14.9997 16.1803Z"
            fill="#E7E7E7"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.9315 25.5815C15.9315 25.5815 24.7714 18.5639 24.7714 10.9866C24.7714 5.76034 20.3931 1.52365 14.9924 1.52365C9.59159 1.52365 5.21339 5.76034 5.21329 10.9866C5.21329 18.5639 14.0531 25.5815 14.0531 25.5815C14.5697 25.9916 15.415 25.9916 15.9315 25.5815ZM14.9997 16.1803C18.0146 16.1803 20.4585 13.8153 20.4585 10.8979C20.4585 7.98055 18.0146 5.61556 14.9997 5.61556C11.9849 5.61556 9.54095 7.98055 9.54095 10.8979C9.54095 13.8153 11.9849 16.1803 14.9997 16.1803Z"
            fill="#909090"
          />
        </svg>
        <button class="link link--pseudo" type="button">{{ $t('my_current_place') }}</button>
      </div>
    </div>
    <slot name="toggle-filters"></slot>
    <div class="map-spots-wrapper" :class="{
      'map-spots-wrapper--shops': isShops,
      'map-spots-wrapper--services': isServices,
      'map-spots-wrapper--without-add-to-cart': withoutAddToCart
    }">
      <slot name="filters"></slot>
      <div
        class="map-vue"
        :class="{
          'map-vue--without-list': withoutList && !isServices,
          'map-vue--checkout': isCheckout || isProduct,
          'map-vue--services': isServices,
          'map-vue--not-checkout': !isCheckout && !isProduct,
          'map-vue--hidden-mob': !isMapActive && (isCheckout || isProduct || isServices || mailName === 'chooseStore')
        }"
      ></div>
      <div class="map-controls">
        <button class="map-controls__zoom map-controls__zoom--in" @click="zoomIn">+</button>
        <button class="map-controls__zoom" @click="zoomOut">−</button>
      </div>
      <DeliverySpotsList
        :class="{ 'map-vue--hidden-mob': isMapActive, 'delivery-spots--hidden': isServices }"
        v-if="!withoutList"
        :mail-name="mailName"
        :spots-info="spotsList"
        :buy-on-store="buyOnStore"
        :without-add-to-cart="withoutAddToCart"
        :product-id="productId"
        @selectSpot="selectSpot"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import DeliverySpotsList from '../checkout/delivery/DeliverySpotsList'
import MarkerClusterer from '@google/markerclusterer'

export default {
  name: 'VueMap',
  components: { DeliverySpotsList },
  props: {
    withoutAddToCart: {
      type: Boolean
    },
    spotsList: {
      type: Array
    },
    mailName: {
      type: String,
      default: 'pickup'
    },
    ourSpotsList: {
      type: Array
    },
    ourMailName: {
      type: String
    },
    withoutList: Boolean,
    mapHeight: {
      type: Number
    },
    enabledMarkers: {
      type: Array,
      default: () => []
    },
    disabledMarkers: {
      type: Array,
      default: () => []
    },
    filteredShopsByCity: {
      type: Array,
      default: () => []
    },
    isServices: {
      type: Boolean,
      default: false
    },
    productId: {
      type: [Number, String]
    }
  },
  data () {
    return {
      isShops: this.$constants.IS_SHOPS,
      isCheckout: this.$constants.IS_CHECKOUT(),
      isProduct: this.$constants.IS_PRODUCT,
      isCheckoutSuccess: this.$constants.IS_CHECKOUT_SUCCESS(),
      mapInited: false,
      isMapDragged: false,
      buyOnStore: null
    }
  },
  computed: {
    ...mapState({
      map: state => state.map.map,
      markers: state => state.map.markers,
      selectedSpot: state => state.map.selectedSpot,
      citiesZoom: state => state.map.citiesZoom,
      selectedUserLocation: state => state.geoLocation.selectedUserLocation,
      selectedCityOnShops: state => state.shops.selectedCity,
      formData: state => state.checkout.formData,
      isMapActive: state => state.deliveryForm.isMapTabActive,
      userType: state => state.user.userType,
      currLocale: state => state.translation.language
    }),
    isSearchVisible () {
      return (
        (window.config.params.checkout && window.config.params.checkout.show_address_search_field) || !this.isCheckout
      )
    }
  },
  methods: {
    ...mapActions([
      'SET_MAP_ACTION',
      'SET_MAP_POSITION_BY_GEO',
      'HANDLE_ADDRESS_SEARCH',
      'INIT_AUTOCOMPLETE',
      'FIND_ME',
      'OPEN_INFO_WINDOW',
      'SET_SELECTED_SPOT_ACTION',
      'CREATE_MARKERS',
      'HANDLE_SELECT_CITY_WITHOUT_SHOPS',
      'SET_STORE'
    ]),
    handleMapClick (e) {
      const btn = e.target.closest('[data-action="select-store"]')
      if (!btn) return
      const storeId = btn.dataset.storeId
      const title = btn.dataset.title
      this.SET_STORE({ storeId, title }).then((spot) => {
        if (this.productId && !this.withoutAddToCart) {
          this.buy(storeId)
        }
        setTimeout(() => {
          this.$modal.hide('map-modal')
        }, 100)
      })
    },
    buy (storeId) {
      this.buyOnStore = storeId
    },
    createMarkerClusters (map, spots, icon, name) {
      // eslint-disable-next-line no-new
      const clusters = () => {
        return new MarkerClusterer(map, spots, {
          styles: [
            {
              url: icon,
              height: 99,
              width: 75,
              anchor: [24],
              textColor: `#ffffff`,
              textSize: 14
            }
          ],
          maxZoom: 15.5
        })
      }

      if (name) window[name] = clusters()
      else clusters()
    },
    deleteMarkerClusters (names) {
      names.forEach(name => {
        if (window[name]) {
          window[name].clearMarkers()
          delete window[name]
        }
      })
    },
    createClusters () {
      if (this.ourSpotsList) {
        const mailMarkerLastIndex = this.markers.length - this.ourSpotsList.length
        const mailMarkers = this.markers.slice(0, mailMarkerLastIndex)
        const ourSpotsMarkers = this.markers.slice(mailMarkerLastIndex)
        const clusterImg =
          this.mailName === 'ukrposhta' ? '/img/svgo/map/map-cluster-up.svg' : '/img/svgo/map/map-cluster-np.svg'

        this.createMarkerClusters(this.map, ourSpotsMarkers, '/img/svgo/map/map-cluster.svg')
        this.createMarkerClusters(this.map, mailMarkers, clusterImg)
      } else if (this.enabledMarkers.length || this.disabledMarkers.length) {
        this.createMarkerClusters(this.map, this.enabledMarkers, '/img/svgo/map/map-cluster.svg', 'enabledClusters')
        this.createMarkerClusters(
          this.map,
          this.disabledMarkers,
          '/img/svgo/map/map-cluster-disabled.svg',
          'disabledClusters'
        )
      } else {
        let url = this.mailName === 'inpostParcel' ? '/img/svgo/map/map-pin-inpost-cluster.svg' : '/img/svgo/map/map-cluster.svg'
        this.createMarkerClusters(this.map, this.markers, url, 'clusters')
        this.$store.commit('SET_MARKER_CLUSTERS', window.clusters)
      }
    },
    selectFirstOnEnter (autocomplete) {
      const _addEventListener = autocomplete.addEventListener ? autocomplete.addEventListener : autocomplete.attachEvent
      function addEventListenerWrapper (type, listener) {
        if (type === `keydown`) {
          let origListener = listener
          listener = function (event) {
            const suggestionSelected = document.querySelectorAll('.pac-item-selected').length > 0
            if (event.which === 13 && !suggestionSelected) {
              autocomplete.dispatchEvent(new KeyboardEvent('keydown', { keyCode: '40', which: 40 }))
            }
            origListener.apply(autocomplete, [event])
          }
        }
        _addEventListener.apply(autocomplete, [type, listener])
      }
      if (autocomplete.addEventListener) {
        autocomplete.addEventListener = addEventListenerWrapper
      } else if (autocomplete.attachEvent) {
        autocomplete.attachEvent = addEventListenerWrapper
      }
    },
    selectSpot (spot) {
      this.map.setCenter({ lat: +spot.latitude, lng: +spot.longitude })

      if (!(spot.isSuccessful || spot.isWeightDisable || spot.cartStatus === this.$constants.CART_STATUSES.NOT_AVAILABLE)) {
        this.SET_SELECTED_SPOT_ACTION(spot)
        this.$emit('selectSpot', spot)
      }

      this.markers.forEach(marker => {
        if (marker.title === spot.title) {
          this.OPEN_INFO_WINDOW({ marker, spot, mailName: this.mailName })
        }
      })
    },
    selectCity (value) {
      if (this.mapInited) {
        if (this.filteredShopsByCity?.length) {
          const latlng = new window.google.maps.LatLng(+this.filteredShopsByCity[0].latitude, +this.filteredShopsByCity[0].longitude)
          const cityName = value.short_name || value.name[this.currLocale]
          const zoom = this.citiesZoom[cityName.toLowerCase()] || 12
          this.map.setZoom(zoom)
          this.map.setCenter(latlng)
        } else {
          this.HANDLE_SELECT_CITY_WITHOUT_SHOPS(value)
        }
      }
    },
    zoomIn () {
      this.map.setZoom(this.map.getZoom() + 1)
    },
    zoomOut () {
      this.map.setZoom(this.map.getZoom() - 1)
    }
  },
  watch: {
    selectedUserLocation (value) {
      if (this.mapInited) {
        this.isMapDragged = false
        const latlng = new window.google.maps.LatLng(+value.latitude, +value.longitude)
        const zoom = this.citiesZoom[value.name[this.currLocale].toLowerCase()] || 15
        this.map.setZoom(zoom)
        this.map.setCenter(latlng)
      }
    },
    selectedCityOnShops (value) {
      this.selectCity(value)
    },
    enabledMarkers () {
      this.deleteMarkerClusters(['enabledClusters', 'disabledClusters', 'clusters'])
      this.createClusters()
    },
    spotsList (value, prevValue) {
      if (value !== prevValue && (this.isShops || (this.isProduct && !this.isMapDragged) || this.isServices) && this.mapInited) {
        this.CREATE_MARKERS({
          spotsInfo: this.spotsList,
          ourSpotsInfo: this.ourSpotsList,
          mailName: this.mailName,
          ourMailName: this.ourMailName,
          modal: this.$modal
        })
        this.createClusters()
      }
    },
    userType () {
      if (this.isShops && this.mapInited) {
        this.CREATE_MARKERS({
          spotsInfo: this.spotsList,
          ourSpotsInfo: this.ourSpotsList,
          mailName: this.mailName,
          ourMailName: this.ourMailName,
          modal: this.$modal
        })
        this.createClusters()
      }
    }
  },
  async mounted () {
    document.addEventListener('click', this.handleMapClick)
    await this.$nextTick()
    await this.SET_MAP_ACTION({
      spotsInfo: this.spotsList,
      ourSpotsInfo: this.ourSpotsList,
      mailName: this.mailName,
      ourMailName: this.ourMailName,
      modal: this.$modal
    })
    await this.$nextTick()

    this.mapInited = true

    this.selectCity(this.selectedCityOnShops)

    if (Object.keys(this.selectedCityOnShops).length) {
      if (!this.filteredShopsByCity?.length) {
        this.HANDLE_SELECT_CITY_WITHOUT_SHOPS(this.selectedCityOnShops)
      }
    }

    const ifDeliverySpotSelected =
      this.isCheckout && this.formData.deliveryInfo && this.formData.deliveryInfo.deliverySpot
    const isThankyouPage = this.isCheckoutSuccess

    if (this.isProduct && !this.selectedSpot && (!this.isCheckout || (!ifDeliverySpotSelected && !isThankyouPage))) {
      this.SET_MAP_POSITION_BY_GEO()
    } else if (ifDeliverySpotSelected || isThankyouPage || this.isProduct) {
      let spot
      if (isThankyouPage) {
        spot = this.spotsList[0]
      } else if (this.formData && this.formData.deliveryInfo && this.formData.deliveryInfo.deliverySpot) {
        spot = this.formData.deliveryInfo.deliverySpot
      } else if (this.selectedSpot) {
        spot = this.selectedSpot
      }
      setTimeout(() => {
        this.markers.forEach(marker => {
          if (marker.title === spot.title || marker.title === spot.description) {
            this.OPEN_INFO_WINDOW({ marker, spot, mailName: this.mailName })
          }
        })
      }, 1000)
    }

    if (this.$refs.autocomplete) {
      const autocomplete = new window.google.maps.places.Autocomplete(this.$refs.autocomplete)
      autocomplete.addListener(`place_changed`, () => {
        this.HANDLE_ADDRESS_SEARCH(autocomplete)
      })
      this.INIT_AUTOCOMPLETE(autocomplete)
      this.selectFirstOnEnter(this.$refs.autocomplete)
    }

    this.map.addListener('dragstart', () => {
      this.isMapDragged = true
      this.$emit('dragstart')
    })
    this.map.addListener('dragend', () => {
      this.$emit('dragend')
    })

    if (!window.location.hash) {
      this.createClusters()
    }
  },
  beforeDestroy () {
    document.removeEventListener('click', this.handleMapClick)
  }
}
</script>

<style lang="sass">
.map-spots-wrapper--without-add-to-cart
  .reserve-info__quantity
    display: none !important

.find_me_btn
  width: fit-content
  height: fit-content
  margin-bottom: 15px
  display: flex
  align-items: center
  cursor: pointer

  .link
    margin-left: 10px
    background: transparent

.map-vue
  height: auto
  width: 70%

  &--services
    width: 100%

.map-vue-wrapper
  width: 100%

.map-spots-wrapper
  display: flex
  //flex-direction: column

  &--shops
    position: relative
    flex-direction: column

  &--services
    flex-flow: column
    width: 100vw
    margin: 0 -15px

    +mmin($mid)
      flex-flow: row nowrap
      width: 100%
      margin: 0

.delivery__map
  width: 890px
  height: 730px

  +mmax(1100)
    height: 100vh
    width: 100%

    +mmax(900)
      height: calc(100vh - 90px)

    &--hidden
      display: none

    &--visible
      display: block

.map-vue--not-checkout
  min-height: 600px
  width: 100%

  +mmin(1101)
    &:not(.map-vue--without-list)
      width: 70%

.map-vue-wrapper__search
  margin-bottom: 40px

.map-vue__spots-hidden-mob
  display: none

  +mmin($tablet--hor)
    width: 30%
    display: block

.map-vue-wrapper__nav
  padding: 0 30px
  +mmin($tablet--hor)
    display: flex
  &:empty
    display: none

.map-vue-wrapper__nav-search

  margin-bottom: 15px

  +mmin(540)
    max-width: 400px
    margin-right: 30px

.map-vue--hidden-mob:not(.map-vue--without-list)
  display: none

  +mmin(1101)
    display: block

.map-vue--hidden-mob.map-vue--services
  display: none

  +mmin($mid)
    display: block

.map-vue--checkout
  width: 100%
  height: 100%
  position: absolute

  +mmin(1101)
    width: 70%
    height: auto
    position: relative

.map-vue-wrapper .map-vue--services
  width: 100%

.delivery-spots--hidden
  display: none

  +mmin(1101)
    display: block

.gm-style-pbc
  pointer-events: none
  z-index: 4 !important

.map-vue-wrapper__nav
  display: flex
  align-items: center
  flex-wrap: wrap

.new-line
  width: 100%

  +mmin($tablet--hor)
    display: none
</style>
<style lang="scss">
.map-vue {
  .gmnoprint {
    menu {
      li:nth-child(5),
      li:nth-child(6) {
        display: none !important;
      }
    }
  }
}

.map-controls {
  position: absolute;
  left: calc(100% - 50px);
  bottom: 70px;
  z-index: 1;

  &__zoom {
    border-radius: 50%;
    border: 0;
    background: #fff;
    color: #6f6f6f;
    width: 40px;
    text-align: center;
    height: 40px;
    font-size: 20px;
    line-height: 24px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 5px 0;
    box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;

    &--in {
      margin-bottom: 10px;
    }
  }

  @media (min-width: 1101px) {
    left: calc(70% - 50px);
  }

  .map-spots-wrapper--shops &,
  .map-spots-wrapper--services & {
    left: calc(100% - 50px);
  }
}
</style>
